<template>
  <section>
    <div class="container pt-8 pb-16">
      <div class="flex flex-col lg:flex-row w-full gap-6">
        <div class="w-full lg:w-2/3">
          <h1 class="font-bitter text-3xl font-bold mb-4">
            {{ props.title }}
          </h1>
          <p
            class="mb-4"
            v-if="lead">
            {{ props.lead }}
          </p>
          <slot>
          </slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  title: { required: true, type: String },
  lead: { type: String },
})
</script>
